<h2 mat-dialog-title>Delete fence</h2>
<mat-dialog-content class="pb-12">
  Would you like to delete <b>{{ data.selectedFence?.name }}?</b>
</mat-dialog-content>
<mat-dialog-actions class="">
  <button mat-stroked-button mat-dialog-close>No</button>
  <button
    mat-stroked-button
    color="warn"
    mat-dialog-close
    cdkFocusInitial
    (click)="deleteFence(data.selectedFence)"
  >
    Yes
  </button>
</mat-dialog-actions>
